(() => {
  const setup = (share) => {
    if (share.dataset.shareReady) return;
    share.dataset.shareReady = 'true';
    const title = share.dataset.shareTitle;
    const url = share.dataset.shareUrl || window.location.href;
    const image = share.dataset.shareImage;
    const status = share.querySelector('.dv-product-share__status');
    const setStatus = (text) => {
      if (!status) return;
      status.textContent = text;
      window.setTimeout(() => { status.textContent = ''; }, 2200);
    };
    const systemShare = async () => {
      try {
        await navigator.clipboard.writeText(url);
        setStatus('Link copied');
      } catch {
        setStatus('Copy unavailable');
      }
    };
    share.querySelectorAll('[data-share-action="instagram"],[data-share-action="tiktok"],[data-share-action="pinterest"],[data-share-action="facebook"],[data-share-action="youtube"],[data-share-action="discord"]').forEach(button => button.addEventListener('click', systemShare));
  };
  const placeShare = () => {
    const share = document.querySelector('[data-dv-product-share]');
    if (!share) return;
    if (window.matchMedia('(min-width: 750px)').matches) {
      const photos = document.querySelector('.product__photos');
      if (photos && photos.nextElementSibling !== share) photos.insertAdjacentElement('afterend', share);
      return;
    }
    const reviews = document.querySelector('.dv-loox-review-intro');
    const reviewSection = reviews?.closest('.shopify-section');
    if (reviewSection && reviewSection.nextElementSibling !== share) reviewSection.insertAdjacentElement('afterend', share);
  };
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-dv-product-share]').forEach(setup);
    placeShare();
    requestAnimationFrame(() => document.querySelectorAll('[data-dv-product-share]').forEach(share => share.classList.add('dv-product-share--ready')));
  });
  window.addEventListener('resize', placeShare);
})();
